
import { defineComponent } from "vue";
import CiButton from "@components/base/button.vue";

export default defineComponent({
  name: "CiUsersProfileImprint",
  components: { CiButton },
  inject: {
    slug: "userSlug",
  },
  props: {
    imprint: {
      type: String,
      default: null,
    },
    owner: {
      type: Boolean,
      default: false,
    },
  },
});
